module.exports = __webpack_public_path__ + "img/header.7721e2ab.jpg";